import React from 'react';
import Layout from "../Layout/layout";
import About from "../Pages/About";
import Banner from "../Pages/Banner";
// import Banner from "../newranPages/Banner";
import Contact1 from "../Pages/Contact1";
import Team1 from "../Pages/Team1";
import Service from "../Pages/Service";
import Video1 from "../Pages/Video1";
import News from "../Pages/News";
import Chooseus from "../Pages/Chooseus";
import Fundraise from "../Pages/Fundraise";
import Testimonial from "../Pages/Testimonial";
import ScrollToHash from '../ScrollToHash';
import Service2 from './Service2';
import Skill from './Skills';
import Faq from './Faq';

function Main() {
  return (
    <>
    
    <Layout headerStyle={1} footerStyle={1}>
    <ScrollToHash />
      <Banner id="banner" />
      <Service id="service"/>
      <About id="about" />
      <Service2 id="service2"/>
      {/* <Fundraise id="fundraise" /> */}
      <Skill id="skill" />
      <Chooseus id="chooseus" />
      {/* <Video1 id="video1" /> */}
      {/* <Team1 id="team" /> */}
      {/* <Testimonial id="testimonial" /> */}
      <Faq id="faq" />
      {/* <News id="news" /> */}
      <Contact1 id="contact" />
    </Layout>
    </>
  );
}

export default Main;
